import * as React from "react";
import PaperLayout from "components/PaperLayout/PaperLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {RouteComponentProps} from "react-router-dom";
import {TopicSubscriptionResource} from "../../client/resources/topicSubscriptionResource";
import SimpleDataTable from "../../components/SimpleDataTable";
import OverflowMenu from "../../components/Menu/OverflowMenu";
import ActionList from "../../components/ActionList";
import ActionButton from "../../components/Button";
import PreviewDeadLetterQueueMessagesDialog from "./PreviewDeadLetterQueueMessagesDialog";
import TestEventMessageDialog from "./TestEventMessageDialog";

interface State extends DataBaseComponentState {
    subscriptions?: TopicSubscriptionResource[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props extends RouteComponentProps<{}> {
}

class SubscriptionsDataTable extends SimpleDataTable<TopicSubscriptionResource> {}

class MessageBus extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    
    render() {
        const refreshButton = <ActionButton label="Refresh" disabled={this.state.busy} onClick={() => this.refreshData()}/>;

        return <PaperLayout title="Subscriptions"
                            busy={this.state.busy}
                            errors={this.state.errors}
                            sectionControl={<ActionList actions={[refreshButton]} />}
                            fullWidth={true}>
            {
                <SubscriptionsDataTable
                    data={this.state.subscriptions}
                    onRow={subscription => this.buildSubscriptionRow(subscription)}
                    onRowOverflowMenu={subscription => this.getOverflowMenu(subscription)}
                    headerColumns={["Topic Name", "Name", "Total Message Count", "Active Message Count", "Dead Letter Message Count", "Transfer Dead Letter Message Count"]}
                    onEmpty={<div>No subscriptions found</div>}/>
            }
        </PaperLayout>;
    }

    componentDidMount() {
        this.refreshData();
    }

    private refreshData = async () => {
        await this.doBusyTask(async () => {
            const subscriptions = await repository.MessageBus.listSubscriptions();

            this.setState({
                subscriptions,
            });
        });
    };

    private buildSubscriptionRow = (subscription: TopicSubscriptionResource) => {
        return [
            subscription.TopicName,
            subscription.Name,
            subscription.TotalMessageCount,
            subscription.ActiveMessageCount,
            subscription.DeadLetterMessageCount,
            subscription.TransferDeadLetterMessageCount
        ];
    }
    
    private getOverflowMenu(subscription: TopicSubscriptionResource) {
        const previewItem = OverflowMenu.dialogItem("Preview messages from DLQ", <PreviewDeadLetterQueueMessagesDialog subscription={subscription} />, "large");
        const sendTestEventMenuItem = OverflowMenu.dialogItem("Send Test Message", <TestEventMessageDialog />);

        return (subscription.TopicName === "cloudplatform")
            ? [previewItem, sendTestEventMenuItem]
            : [previewItem];
    }
}

export default MessageBus;